import React from "react";
import { Box, Divider } from "@mui/material";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import PlaceOutlined from "@mui/icons-material/PlaceOutlined";
import Grid2 from "@mui/material/Grid2";
import { SectionHeader } from "../layout/SectionHeader";
import { FormField } from "../fields/FormField";
import { ProfileFormGrid } from "../ProfileFormGrid";
import { SedeAziendale } from "../sede/SedeAziendale";
import VatNumberField from "../../../../Shared/VatNumberField";
import { fieldLabel } from "../../constants";
import { ProfileReadOnlyField } from "../fields/ProfileReadOnlyField";
import {
  profileSectionDividerSx,
  profileSubsectionShellSx,
  profileVatNumberFieldSx,
} from "../../profileFieldStyles";

export function DatiAziendali({
  vendorForm,
  fieldErrors,
  onChange,
  readOnly = false,
  enableLegalAddressValidation,
  sedeAddressValues,
  onSedeFieldChange,
  hasStoredAddress,
  addressNeedsReverify,
  onSedeVerifiedMerge,
  onSedeResetToVerified,
  onGeocodeServiceUnavailable,
  locationiqApiKey: locationiqApiKeyProp,
}) {
  const v = vendorForm ?? {};
  const err = fieldErrors ?? {};

  return (
    <Box sx={profileSubsectionShellSx}>
      <SectionHeader title="Dati aziendali" icon={BusinessOutlined} />
      <ProfileFormGrid>
        <FormField
          name="ragioneSociale"
          value={v.ragioneSociale}
          errorMessage={err.ragioneSociale}
          onChange={onChange}
          readOnly={readOnly}
        />
        {readOnly ? (
          <ProfileReadOnlyField label={`${fieldLabel("partitaIVA")}*`} value={v.partitaIVA} />
        ) : (
          <Grid2 xs={12} md={6}>
            <VatNumberField
              variant="application"
              size="medium"
              name="partitaIVA"
              label={fieldLabel("partitaIVA")}
              value={v.partitaIVA}
              onChange={onChange}
              error={!!err.partitaIVA}
              helperText={err.partitaIVA || ""}
              required
              sx={profileVatNumberFieldSx}
            />
          </Grid2>
        )}
        <FormField
          name="codiceFiscale"
          value={v.codiceFiscale}
          errorMessage={err.codiceFiscale}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="numeroTelefono"
          value={v.numeroTelefono}
          errorMessage={err.numeroTelefono}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="indirizzoEmail"
          value={v.indirizzoEmail}
          errorMessage={err.indirizzoEmail}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="indirizzoPec"
          value={v.indirizzoPec}
          errorMessage={err.indirizzoPec}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="codiceSDI"
          value={v.codiceSDI}
          errorMessage={err.codiceSDI}
          onChange={onChange}
          readOnly={readOnly}
        />
      </ProfileFormGrid>

      <Divider sx={profileSectionDividerSx} />

      <SectionHeader title="Sede legale" icon={PlaceOutlined} />
      <SedeAziendale
        enableValidation={enableLegalAddressValidation}
        value={sedeAddressValues}
        onSedeFieldChange={onSedeFieldChange}
        hasStoredAddress={hasStoredAddress}
        addressNeedsReverify={addressNeedsReverify}
        onVerifiedMerge={onSedeVerifiedMerge}
        onResetToVerified={onSedeResetToVerified}
        onGeocodeServiceUnavailable={onGeocodeServiceUnavailable}
        apiKey={locationiqApiKeyProp || undefined}
        readOnly={readOnly}
      />
    </Box>
  );
}
